import React, { Dispatch, SetStateAction } from 'react';
import {
    Button,
    ButtonProps,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogTitleProps,
    IconButton,
    IconButtonProps,
    TextField,
    TextFieldProps,
    Typography,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import * as certificateService from "services/certificate-service";
import * as Styles from "pages/employee/certificates/certificateDetails/certificateDetails.styles";
import { useTranslation } from 'react-i18next';
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useParams } from 'react-router-dom';
import 'dayjs/locale/nl';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import DatePicker from 'components/formsUI/DatePicker/DatePicker';

interface IProps {
    open: boolean;
    onClose: (event: any, reason: string) => void;
    handleClose: () => void;
    updateCertificate: Dispatch<CertificateWithDetails>;
    dateCertificate?: Date
}

const OutOfServiceModal = (props: IProps) => {
    const { open, onClose, handleClose, updateCertificate } = props;
    const { certificateId } = useParams();
    const theme = useTheme();
    const { t, i18n: { language } } = useTranslation();

    const [date, setDate] = React.useState<Dayjs>(props.dateCertificate !== null && props.dateCertificate !== undefined ? dayjs(props.dateCertificate) : dayjs());

    const handleSubmit = (): void => {
        if (date !== null && date !== undefined && certificateId !== undefined) {
            certificateService.setOutOfService(certificateId, date).then((res) => {
                updateCertificate(res);
                handleClose();
            });
        }
    }

    const statusDialogTitle: DialogTitleProps = {
        sx: Styles.statusDialogTitle(theme)
    };

    const closeDialogIconButton: IconButtonProps = {
        sx: Styles.closeDialogIconButton(theme)
    };

    const statusDialogCancelButton: ButtonProps = {
        variant: "contained",
        sx: Styles.statusDialogCancelButton(theme)
    };

    return (
        <Dialog
            fullWidth
            open={open}
            onClose={onClose}
            aria-labelledby="out-of-service-modal"
        >
            <DialogTitle {...statusDialogTitle}>
                {t("certificateWithDetail.OOS.title")}
                <IconButton {...closeDialogIconButton}
                    aria-label="close"
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" gutterBottom>
                    {t("certificateWithDetail.OOS.info")}
                </Typography>
                <DatePicker
                    disablePast={true}
                    onChange={(day: Dayjs | null) => setDate(day as Dayjs)}
                    value={date}
                    renderInput={(params: TextFieldProps) => <TextField {...params} />}
                    inputFormat="DD/MM/YYYY" />
            </DialogContent>
            <DialogActions>
                <Button {...statusDialogCancelButton} onClick={handleClose}>
                    {t("requestWithDetail.cancelButton")}
                </Button>
                <Button variant="contained" color="success" autoFocus onClick={handleSubmit} disabled={false}>
                    {t("requestWithDetail.confirmButton")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OutOfServiceModal;
